import {UIGameManager} from '../UIGameManager'
import {UIGamePopupConfirmationButtons} from './UIGamePopupConfirmationButtons'
import {UIGamePopupInformationView} from './UIGamePopupInformationView'
import {SectionBgAdaptiveView} from '../../ui_canvas_engine/SectionBgViewAdaptive'
import {CardDataController, CardPopupInformation} from '@colonist/game-card-types'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameCanvasController} from '../UIGameCanvasController'
import {CardEnum} from '@colonist/game-states'
import {PopupInformation} from '@colonist/game-base-types'
import {CARD_IMAGES, CARD_TIP_TITLE} from '@colonist/ui-game'

export abstract class UIGamePopupCardConfirmation extends SectionBgAdaptiveView {
    protected readonly uiGameManager: UIGameManager
    protected readonly cardEnum: CardEnum
    protected confirmationButtons: UIGamePopupConfirmationButtons
    protected cardPopupInformation: UIGamePopupInformationView
    protected readonly canvas: UIGameCanvasController
    protected readonly popupInformation: PopupInformation
    protected onCheckButton: () => void
    protected onCancelButton: () => void

    constructor(uiGameManager: UIGameManager, popupInformationFormat: CardPopupInformation) {
        super()
        this.uiGameManager = uiGameManager
        this.cardEnum = popupInformationFormat.cardEnum
        this.canvas = this.uiGameManager.canvasController

        const card = CardDataController.getCardDataForCard(this.cardEnum)
        if(card == undefined) throw new Error('Unable to determine card information for card')

        this.popupInformation = {
            imagePath: CARD_IMAGES[this.cardEnum],
            title: CARD_TIP_TITLE[this.cardEnum],
            body: popupInformationFormat.cardBody,
        }

        this.canvas.app.stage.addChild(this)

        this.onCheckButton = () => {
            this.uiGameManager.socketGameSend.clickedDevelopmentCard(this.cardEnum)
            this.closeUI()
        }
        this.onCancelButton = () => {
            this.uiGameManager.socketGameSend.cancelAction()
            this.closeUI()
        }

        this.createPopupView()
        this.drawTextureBgAroundContent()
        this.setContainerY()
    }

    private setContainerY() {
        this.y = this.canvas.appH - this.canvas.bottomViewHeight - this.absoluteHeight
    }

    protected abstract createPopupView()

    setCheckAction(action: () => void) {
        this.onCheckButton = action
        this.confirmationButtons.checkButton.updateAction(action)
    }

    abstract setCancelAction(action: () => void)

    checkButtonInactiveOpacity() {
        this.confirmationButtons.checkButton.inactivateOpacity()
    }

    checkButtonActiveOpactiy() {
        this.confirmationButtons.checkButton.activateOpacity()
    }

    private closeUI() {
        if(this.parent == undefined) return
        this.parent.removeChild(this)
        this.uiGameManager.eventController.sendEvent(undefined, GameStateEnums.UIGameEventEnums.ClosePopupUI)
        this.destroy()
    }
}
